export default __webpack_public_path__ + "static/media/warranty.e650ff6c.png";